"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_router_dom_1 = require("react-router-dom");

var core_1 = require("@material-ui/core");

exports.default = function (_ref) {
  var to = _ref.to,
      children = _ref.children;
  return react_1.default.createElement(core_1.Link, {
    component: react_router_dom_1.Link,
    to: to
  }, children);
};